module.exports = __webpack_public_path__ + "img/european-comision-logo-en.30b933cc.svg";